import { useState } from "react";

const House = ({ house }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const isSoldOrRented =
    house.state === "Vendido" || house.state === "Alquilado";

  const handleImageLoad = () => {
    setIsImageLoaded(true);
  };

  return (
    <div className="relative mx-auto w-full max-w-xl pt-6">
      <div className="rounded-lg bg-primary/90 shadow-md hover:shadow-lg transition-shadow duration-300">
        <div className="relative flex h-72 justify-center overflow-hidden rounded-t-lg">
          <div className="w-full transform transition-transform duration-500 ease-in-out hover:scale-110">
            {/* Image with onLoad handler */}
            {!isImageLoaded && (
              <div className="w-full h-full animate-pulse bg-gray-300 rounded-t-lg"></div>
            )}
            <img
              src={house.images[0]}
              alt={house.name}
              onLoad={handleImageLoad}
              className={`transition-opacity duration-300 h-full w-full object-cover ${
                isImageLoaded ? "opacity-100" : "opacity-0"
              }`}
            />
          </div>

          <div className="absolute bottom-0 mb-3 flex justify-center">
            {/* Other content */}
          </div>

          <span className="absolute left-0 top-0 z-10 ml-3 mt-3 inline-flex select-none rounded-lg bg-[#4EB8A3] px-3 py-2 text-sm font-medium text-white">
            {house.state}
          </span>
        </div>

        <div className="px-2 pb-4">
          <div className="mt-4 grid grid-cols-2">
            <div className="flex items-center">
              <div className="relative">
                <h2
                  className="line-clamp-1 text-base font-medium text-white md:text-lg"
                  title="New York"
                >
                  {house.name}
                </h2>
                <p
                  className="mt-2 line-clamp-1 text-sm text-white"
                  title="New York, NY 10004, United States"
                >
                  {house.address}
                </p>
              </div>
            </div>

            <div className="flex items-center justify-end">
              <p className="text-white inline-block whitespace-nowrap rounded-xl font-semibold leading-tight">
                {isSoldOrRented ? (
                  house.state
                ) : house.currency !== "" ? (
                  <>
                    {house.currency} {house.price}
                  </>
                ) : (
                  "Consultar"
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default House;
